import { store } from '../index';
import { React } from "react";
import { useState, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import defaultimg from "../assets/images/default.png";
import VegIcon from "../assets/images/Veg Icon 1.svg";
import NonVegIcon from "../assets/images/Non Veg Icon 1.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import thumb from "../assets/images/Orderstatus.svg";
import { clearCart } from "../store/actions/cartActions";
import {
  clear_customer,
  clear_order_details,
  clear_order_type,
  clear_last_order,
  clearStateData,
  clear_applied_offer,
} from "../store/actions/action";
import Confetti from "react-confetti";
import DownloadIcon from "@mui/icons-material/Download";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import orderNoIcon from "../assets/web/order-no.svg";
import clockIcon from "../assets/web/clock.svg";
import { Grid, Typography, Button, Box } from "@material-ui/core";
import { BUTTON_COLOR, TEXT_COLOR, TOKEN_KEY } from "../utils/constant";
import { useWindowSize } from "@react-hook/window-size";
import { hexToCSSFilter } from "hex-to-css-filter";
import FSR_OrderStatus from "../assets/images/FSR-Icons/FSR-OrderStatus.svg";
import { associated_stores } from "../store/actions/action";
import { send_order_receipt, download_invoice } from "../utils/order_helper";
import { positions } from "@mui/system";
import CircularProgress from "@mui/material/CircularProgress";
// Payment Methods Icon
const PaymentMethodsIcon = ({ primaryColor = "#3159A6" }) => (
  <svg
    width="28"
    height="24"
    viewBox="0 0 24 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6237 14.6819H2.57132C1.88991 14.6819 1.23637 14.4087 0.753183 13.9229C0.271065 13.4372 0 12.7786 0 12.091V5.18184H21.4287V10.3637C20.997 10.3626 20.562 10.4716 20.1666 10.6972C19.7091 9.97718 18.9088 9.50003 17.9992 9.50003H16.285C16.285 8.66339 15.8822 7.84292 15.1397 7.34417C13.9601 6.5507 12.3616 6.87241 11.5742 8.06316L9.86102 10.6541C9.58033 11.0772 9.42819 11.5738 9.42819 12.091C9.42819 12.607 9.58032 13.1047 9.86102 13.5278L10.6237 14.6819ZM0 3.45456V2.59092C0 1.90324 0.271059 1.24472 0.753183 0.758925C1.23637 0.273131 1.88991 0 2.57132 0H18.8574C19.5388 0 20.1924 0.273125 20.6745 0.758925C21.1566 1.24472 21.4287 1.90324 21.4287 2.59092V3.45456H0ZM21.5412 16.4091H17.1421C16.6685 16.4091 16.2861 16.0227 16.2861 15.5455C16.2861 15.0694 16.6685 14.6819 17.1421 14.6819H21.5412L20.7141 13.4328C20.4527 13.0377 20.5598 12.5001 20.9519 12.2356C21.3462 11.9711 21.8787 12.0791 22.1412 12.4753L23.8554 15.0662C23.9486 15.2076 24 15.3739 24 15.5455C24 15.7183 23.9486 15.8834 23.8554 16.0238L22.1412 18.6147C21.8787 19.012 21.3462 19.1199 20.9519 18.8544C20.5598 18.591 20.4527 18.0544 20.7141 17.6572L21.5412 16.4091ZM11.2869 12.5702C11.1926 12.4287 11.1423 12.2625 11.1423 12.0908C11.1423 11.9181 11.1926 11.7529 11.2869 11.6126L13.0011 9.02167C13.2625 8.6244 13.7961 8.51645 14.1893 8.78201C14.5835 9.04542 14.6885 9.58195 14.4271 9.97923L13.6 11.2272H17.9991C18.4727 11.2272 18.8573 11.6136 18.8573 12.0908C18.8573 12.5669 18.4727 12.9545 17.9991 12.9545H13.6L14.4271 14.2035C14.6885 14.5986 14.5835 15.1362 14.1893 15.4007C13.7961 15.6652 13.2625 15.5572 13.0011 15.161L11.2869 12.5702Z"
      fill={primaryColor}
    />
  </svg>
);

const OrderNoSvgIcon = ({ color = "#EB5C24" }) => (
  <svg width="17" height="20" viewBox="0 0 17 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
    <path
      d="M11.4623 0H0.725463C0.33164 0 0 0.33164 0 0.725463V22.4893C0 22.8832 0.33164 23.2148 0.725463 23.2148H15.442C15.8358 23.2148 16.1675 22.8832 16.1675 22.4893V4.26987L11.4623 0ZM12.8511 13.2656H3.3164C3.0884 13.2656 2.90185 13.0791 2.90185 12.8511C2.90185 12.623 3.0884 12.4365 3.3164 12.4365H12.8511C13.0791 12.4365 13.2656 12.623 13.2656 12.8511C13.2656 13.0791 13.0791 13.2656 12.8511 13.2656ZM12.8511 11.1929H3.3164C3.0884 11.1929 2.90185 11.0063 2.90185 10.7783C2.90185 10.5503 3.0884 10.3638 3.3164 10.3638H12.8511C13.0791 10.3638 13.2656 10.5503 13.2656 10.7783C13.2656 11.0063 13.0791 11.1929 12.8511 11.1929ZM12.8511 9.1201H3.3164C3.0884 9.1201 2.90185 8.93355 2.90185 8.70555C2.90185 8.47755 3.0884 8.291 3.3164 8.291H12.8511C13.0791 8.291 13.2656 8.47755 13.2656 8.70555C13.2656 8.93355 13.0791 9.1201 12.8511 9.1201ZM12.8511 7.04735H3.3164C3.0884 7.04735 2.90185 6.8608 2.90185 6.6328C2.90185 6.4048 3.0884 6.21825 3.3164 6.21825H12.8511C13.0791 6.21825 13.2656 6.4048 13.2656 6.6328C13.2656 6.8608 13.0791 7.04735 12.8511 7.04735ZM11.8354 4.1455C11.711 4.1455 11.6074 4.04186 11.6074 3.9175V1.26438L14.7994 4.1455H11.8354Z"
      fill={color}
    />
  </svg>
);

const ClockSvgIcon = ({ color = "#EB5C24" }) => (
  <svg width="20" height="20" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
    <path
      d="M14 0C12.1615 0 10.341 0.362121 8.64243 1.06569C6.94387 1.76925 5.40053 2.80048 4.1005 4.1005C1.475 6.72601 0 10.287 0 14C0 17.713 1.475 21.274 4.1005 23.8995C5.40053 25.1995 6.94387 26.2307 8.64243 26.9343C10.341 27.6379 12.1615 28 14 28C17.713 28 21.274 26.525 23.8995 23.8995C26.525 21.274 28 17.713 28 14C28 12.1615 27.6379 10.341 26.9343 8.64243C26.2307 6.94387 25.1995 5.40053 23.8995 4.1005C22.5995 2.80048 21.0561 1.76925 19.3576 1.06569C17.659 0.362121 15.8385 0 14 0ZM19.88 19.88L12.6 15.4V7H14.7V14.28L21 18.06L19.88 19.88Z"
      fill={color}
    />
  </svg>
);

// OT Status Icon
const OTStatusIcon = ({ primaryColor = "#3159A6" }) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.309 15.6834C20.6672 16.222 20.5274 16.9569 19.9987 17.3212L17.0167 19.3762C15.6716 20.3031 14.1011 20.794 12.4763 20.794L4.82529 20.7929V21.0098C4.82529 21.5558 4.4038 22 3.88638 22H2.10553C1.58708 22 1.16661 21.5558 1.16661 21.0098V14.8823C1.16661 14.3363 1.5881 13.8921 2.10553 13.8921H3.88638C4.40482 13.8921 4.82529 14.3363 4.82529 14.8823V15.6233H4.92224C5.45702 15.6233 5.97034 15.394 6.33161 14.9944C6.74085 14.5419 7.32359 14.2814 7.92877 14.2814H12.6416C12.9417 14.2814 13.2254 14.4007 13.4377 14.6166C13.6499 14.8325 13.7673 15.12 13.7673 15.4261C13.7673 16.0572 13.2621 16.5709 12.6416 16.5709H9.93812C9.66256 16.5709 9.43804 16.7993 9.43804 17.0795C9.43804 17.3597 9.66256 17.5881 9.93812 17.5881H13.5631C14.2724 17.5881 14.9776 17.4065 15.6021 17.0629L18.7945 15.3068C19.3221 15.0162 19.9732 15.1779 20.309 15.6834ZM21.4908 11.2932H20.3069C20.1916 9.13443 19.3568 7.08243 17.926 5.46857C16.5166 3.87852 14.6336 2.82715 12.5783 2.47122L12.6589 2.0301C12.6783 1.92528 12.6875 1.81837 12.6875 1.71251C12.6875 0.768031 11.0005 0 11.0005 0C10.4974 0 10.0249 0.225223 9.70342 0.619611C9.38194 1.01298 9.25029 1.52777 9.34317 2.03114L9.42379 2.47119C7.36841 2.82824 5.48661 3.87858 4.07607 5.46855C2.64525 7.08246 1.81045 9.13334 1.69513 11.2932H0.510266C0.228602 11.2932 0 11.5257 0 11.8122C0 12.0986 0.228602 12.3311 0.510266 12.3311H2.19009H2.19111H19.8089H19.8099H21.4897C21.7714 12.3311 22 12.0986 22 11.8122C22.001 11.5257 21.7724 11.2932 21.4908 11.2932Z"
      fill={primaryColor}
    />
  </svg>
);

const OrderSummary = function (props) {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [showAllItems, setShowAllItems] = useState(false);
  const orderListContentRef = useRef(null);

  const hexToRgb = (hex) => {
    if (!hex) return "49, 89, 166";
    hex = hex.replace("#", "");
    if (hex.length === 3) {
      hex = hex.split("").map(char => char + char).join("");
    }
    const num = parseInt(hex, 16);
    return `${(num >> 16) & 255}, ${(num >> 8) & 255}, ${num & 255}`;
  };

  const handleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    if (isCollapsed) return;

    const scrollTimer = setTimeout(() => {
      orderListContentRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);

    return () => clearTimeout(scrollTimer);
  }, [isCollapsed]);
  const windowSize = useWindowSize();
  const screenWidth = Array.isArray(windowSize) ? windowSize[0] : (typeof window !== "undefined" ? window.innerWidth : 1024);
  const { cartProps, reducer } = props;
  const { addedItems, orderPlace, selectedTender } = cartProps;
  const { customer } = reducer;
  const sessionReducer = useSelector(state => state.sessionReducer) || {};
  const storeInfo = sessionReducer?.store_details;
  const storeInfoConfig = sessionReducer?.store_config;
  const isSmsReceiptEnabled =
    storeInfoConfig?.general_config?.is_sms_receipt !== false;

  let primaryColor = storeInfoConfig?.general_config?.primary_color || "#272727";
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;
  let tip_enable = storeInfoConfig?.web_ordering_setting?.tip_option_qr;


  const getFSRStatus = () => {
    return sessionReducer?.is_fsr === true;
  };
  const isFSR = getFSRStatus();
  const primaryFilter = (() => {
    try {
      const filterRes = hexToCSSFilter(primaryColor);
      return `brightness(0) ${filterRes.filter}`;
    } catch (e) {
      console.error("Error computing CSS filter for FSR OrderStatus:", e);
      return "";
    }
  })();

  let storeCurrency = storeInfo?.store_currency;
  const [currency, setCurrency] = useState(() => {
    switch (storeCurrency) {
      case "INR":
        return "₹";
      case "USD":
        return "$";
      case "CAD":
        return "$";
      case "OMR":
        return "OMR ";
      case "AED":
        return "AED ";
      default:
        return "$"; // default to dollar if no match
    }
  });

  const stores = reducer?.associated_stores;
  const [isAnimationActive, setAnimationActive] = useState(true);
  const navigate = useNavigate();

  // Helper to extract the current table number for localStorage key cleanup
  const getTableNumber = () => {
    let fsrObject = sessionReducer.table_details || {};
    if (sessionReducer.is_fsr === true) {
      return (fsrObject?.table_no || "").replace(/^table_|^tent_/i, "");
    }
    const tent = sessionReducer.table_details?.table_no || sessionReducer.tent_id || "";
    const activeSession = localStorage.getItem(TOKEN_KEY);
    const user = activeSession ? JSON.parse(activeSession)?.user : null;
    const locId = sessionReducer.location_id || user?.location_id || "";
    const rawTable = tent || locId || "";
    return String(rawTable).replace(/^table_|^tent_/i, "");
  };

  // On mount, if the placed order is CLOSE, remove cached ACTIVE_TABLE_ORDER keys
  // so that a rescan or "order again" starts a fresh order
  useEffect(() => {
    const placedOrder = orderPlace?.[0];
    if (placedOrder) {
      const status = (placedOrder.order_status || "").toUpperCase();
      const state = (placedOrder.order_state || "").toUpperCase();
      const isClosed = status === "CLOSE" || status === "CLOSED" || status === "COMPLETED" || status === "COMPLETE" || status === "CANCELLED" ||
                       state === "CLOSE" || state === "CLOSED" || state === "COMPLETED" || state === "COMPLETE" || state === "CANCELLED";
      if (isClosed) {
        const tableNo = String(
          placedOrder?.store_details?.table_no || placedOrder?.table_no || getTableNumber() || ""
        ).replace(/^table_|^tent_/i, "");
        if (tableNo) {
          store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo } });
          /* cleared above */
        }
      }
    }
  }, []);

  const handleClearStorage = () => {
    const isFSR = getFSRStatus();
    
    // Clean up FSR table order cache
    const tableNo = getTableNumber();
    if (tableNo) {
      store.dispatch({ type: 'CLEAR_ACTIVE_TABLE_ORDER', payload: { tableNo: tableNo } });
      /* cleared above */
    }
    
    props.clearCart();
    props.clear_order_details();
    props.clear_last_order();
    props.clear_applied_offer();

    if (isFSR) {
      // For FSR, keep table number and customer session, go back to menu to start fresh order
      navigate("/menu");
    } else {
      // For QSR, wipe session and reload to login
      localStorage.removeItem("TENT");
      props.clear_order_type();
      props.clearStateData();
      navigate("/");
      window.location.reload();
    }
  };

  useEffect(() => {
    if (customer?.cust_mobile && isSmsReceiptEnabled) {
      SendSMS();
    }
  }, [customer?.cust_mobile, isSmsReceiptEnabled]);

  const SendSMS = async () => {
    try {
      const resp = await send_order_receipt({
        email: false,
        email_id: "",
        mobile: customer?.cust_mobile,
        order_id: orderPlace?.[0]?._id,
        sms: true,
      });
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };
  const [downloading, setDownloading] = useState(false);
  const DownloadInvoice = async () => {
    try {
      setDownloading(true);
      const resp = await download_invoice({
        _id: orderPlace?.[0]?._id,
        orderNo: orderPlace?.[0]?.invoice_no,
      });
      setDownloading(false);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    }
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    DownloadInvoice();
  };

  //Auto Timeout code
  // let timer;

  // useEffect(() => {
  //   const resetTimer = () => {
  //     clearTimeout(timer);
  //     timer = setTimeout(timerElapsed, 12000);
  //   };

  //   const timerElapsed = () => {
  //     // Do something when the timer elapses, e.g., navigate
  //     navigate("/");
  //   };

  //   const handleUserActivity = () => {
  //     resetTimer();
  //   };

  //   window.onload = resetTimer;
  //   document.onkeypress = handleUserActivity;
  //   document.onmousemove = handleUserActivity;
  //   document.onmousedown = handleUserActivity;
  //   document.ontouchstart = handleUserActivity;
  //   document.onclick = handleUserActivity;
  //   document.onscroll = handleUserActivity;
  //   document.ontouchmove = handleUserActivity;
  //   document.ontouchclick = handleUserActivity;

  //   return () => {
  //     clearTimeout(timer);
  //   };
  // }, []);
  // If user accesses /order-status without an active placed order, redirect to home immediately
  useEffect(() => {
    if (!orderPlace || !orderPlace.length || !orderPlace[0]) {
      navigate("/", { replace: true });
    }
  }, [orderPlace, navigate]);

  // Disable browser back button on /order-status to prevent outside UI navigation
  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);

    const handleBackButton = (event) => {
      event.preventDefault();
      window.history.pushState(null, null, window.location.pathname);
    };

    window.addEventListener("popstate", handleBackButton);

    return () => {
      window.removeEventListener("popstate", handleBackButton);
    };
  }, []);

  const groupBy = function (xs, key) {
    return xs.reduce(function (rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };

  // const ItemGroupByStore = groupBy(addedItems, "store_id");
  // console.log(ItemGroupByStore);

  const groupItems = (itemDetails) => {
    if (!itemDetails || !Array.isArray(itemDetails)) return [];

    const mainItems = [];
    const subItemsMap = {};

    // Group all items that have a main_item_id
    itemDetails.forEach((item) => {
      const mainId = item.main_item_id;
      if (mainId) {
        if (!subItemsMap[mainId]) {
          subItemsMap[mainId] = [];
        }
        subItemsMap[mainId].push(item);
      }
    });

    // Collect main items
    itemDetails.forEach((item) => {
      if (!item.main_item_id) {
        mainItems.push({
          ...item,
          subItems: [],
        });
      } else {
        const parentExists = itemDetails.some(
          (p) => String(p._id) === String(item.main_item_id) || 
                 String(p.item_id) === String(item.main_item_id) ||
                 String(p.sku) === String(item.main_item_id)
        );
        if (!parentExists) {
          mainItems.push({
            ...item,
            subItems: [],
          });
        }
      }
    });

    // Assign sub-items to their matching parents
    mainItems.forEach((parent) => {
      const subItems = [];
      const seenIds = new Set();

      const addSubItems = (list) => {
        if (list) {
          list.forEach((sub) => {
            if (!seenIds.has(sub)) {
              seenIds.add(sub);
              subItems.push(sub);
            }
          });
        }
      };

      if (parent._id) addSubItems(subItemsMap[parent._id]);
      if (parent.item_id) addSubItems(subItemsMap[parent.item_id]);
      if (parent.sku) addSubItems(subItemsMap[parent.sku]);

      parent.subItems = subItems;
    });

    return mainItems;
  };

  const getCumulativePrice = (parent) => {
    // The server-computed sub_total on the main item already includes the price
    // of its addons. Adding the flat addon rows' sub_totals on top would
    // double-count them (visible as inflated per-row prices).
    return parseFloat(parent.sub_total || parent.total_net_sale || 0);
  };

  const formatPrice = (val) => {
    if (val === undefined || val === null) return "0.00";
    return val.toFixed(2);
  };

  const getDietaryIcon = (t) => {
    let dietary = (t?.dietary || t?.item_dietary || "").toLowerCase().trim();
    if (dietary === "veg") return VegIcon;
    if (dietary === "non-veg" || dietary === "nonveg" || dietary === "non veg" || dietary === "non_veg" || dietary === "egg" || dietary === "eggetarian" || dietary === "eggiterian" || dietary === "eggitarian") return NonVegIcon;
    if (t?.item_name) {
      const name = t.item_name.toLowerCase();
      if (name.includes("chicken") || name.includes("egg") || name.includes("mutton") || name.includes("fish") || name.includes("meat") || name.includes("bacon") || name.includes("wings")) {
        return NonVegIcon;
      }
    }
    return VegIcon;
  };

  const isCashOrPayLater = () => {
    const placedPayment = orderPlace?.[0]?.payment_details?.[0];
    const selectedTnd = selectedTender;
    const type = (placedPayment?.tnd_type || selectedTnd?.tnd_type || "").toLowerCase();
    const code = (placedPayment?.tnd_code || selectedTnd?.tnd_code || "").toLowerCase();
    return type.includes("cash") || type.includes("paylater") || type.includes("pay later") || code === "pl";
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setAnimationActive(false);
    }, 5000);
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  if (!orderPlace || !orderPlace.length || !orderPlace[0]) {
    return null;
  }

  const isDesktop = screenWidth >= 768 && !getFSRStatus();

  if (isDesktop) {
    const storeName = orderPlace?.[0]?.store_details?.store_name || storeInfo?.store_name || "Casa Carne";
    const storeLogo = orderPlace?.[0]?.store_details?.store_logo || orderPlace?.[0]?.store_details?.store_display_logo || storeInfo?.store_display_logo || defaultimg;
    const orderNo = orderPlace?.[0]?.invoice_no || "";
    const isFSR = getFSRStatus();
    const allItems = (orderPlace || []).flatMap(item => 
      isFSR 
        ? groupItems(item?.item_details)
        : (item?.item_details || []).filter(t => !t?.main_item_id)
    );
    const visibleItems = showAllItems ? allItems : allItems.slice(0, 3);
    const remainingCount = allItems.length - 3;

    const roundOffSetting = storeInfoConfig?.general_config?.round_off;
    const configApplyFor = (storeInfoConfig?.general_config?.apply_for || "").toLowerCase();
    const configPaymentTypes = storeInfoConfig?.general_config?.payment_types || storeInfoConfig?.general_config?.round_off_payments;

    const currentTnd = orderPlace?.[0]?.payment_details?.[0] || selectedTender;
    const currentTndType = (currentTnd?.tnd_type || "").toLowerCase();
    const currentTndCode = (currentTnd?.tnd_code || "").toLowerCase();

    let isRoundOffApplicable = false;
    if (roundOffSetting === true || roundOffSetting === "true") {
      if (configApplyFor.includes("cash only")) {
        isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
      } else if (configApplyFor.includes("selected payments") || Array.isArray(configPaymentTypes)) {
        if (Array.isArray(configPaymentTypes)) {
          isRoundOffApplicable = configPaymentTypes.some(item => {
            if (typeof item === "string") {
              const itemLower = item.toLowerCase();
              return currentTndType === itemLower || currentTndCode === itemLower || currentTndType.includes(itemLower);
            }
            if (typeof item === "object" && item) {
              const itemType = (item.tnd_type || item.type || "").toLowerCase();
              const itemCode = (item.tnd_code || item.code || "").toLowerCase();
              return currentTndType === itemType || currentTndCode === itemCode || (itemType && currentTndType.includes(itemType));
            }
            return false;
          });
        } else {
          isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
        }
      } else {
        isRoundOffApplicable = true;
      }
    }

    const roundOffType = (storeInfoConfig?.general_config?.type || storeInfoConfig?.general_config?.round_off_type || "nearest").toLowerCase();
    const rawTotal = (cartProps?.total || 0) + (cartProps?.total_tax || 0) + (cartProps?.tip || 0);
    let roundedTotal = rawTotal;
    if (isRoundOffApplicable) {
      if (roundOffType === "up") {
        roundedTotal = Math.ceil(rawTotal);
      } else if (roundOffType === "down") {
        roundedTotal = Math.floor(rawTotal);
      } else {
        roundedTotal = Math.round(rawTotal);
      }
    }
    const roundOffAmount = roundedTotal - rawTotal;

    const formatRoundOff = (val) => {
      if (val === 0) return "0.00";
      const formatted = Math.abs(val).toFixed(2);
      return val > 0 ? `+${currency} ${formatted}` : `-${currency} ${formatted}`;
    };

    const reduxTotals = (() => {
      const targetOrder = orderPlace?.[0];
      if (!targetOrder) return null;
      // Prefer engine-calculated base (tax-exclusive) sub_total
      const itemTotal = parseFloat(targetOrder.sub_total ?? targetOrder.total_item_price ?? 0);
      const tax = parseFloat(targetOrder.total_item_tax || 0);
      const discount = parseFloat(targetOrder.total_discount || 0);
      let finalTotal = parseFloat(targetOrder.rounded_total || targetOrder.transaction_grand_amount || targetOrder.grand_total || 0);
      let roundOffAmt = parseFloat(targetOrder.round_off_amount || 0);
      if (targetOrder.payment_details && targetOrder.payment_details.length > 0) {
         const pd = targetOrder.payment_details[0];
         if (pd.round_off_amount !== undefined && pd.round_off_amount !== 0) {
             roundOffAmt = parseFloat(pd.round_off_amount);
             finalTotal = parseFloat(pd.amount || finalTotal);
         }
      }
      return {
        itemTotal,
        tax,
        discount,
        total: finalTotal,
        roundOffAmount: roundOffAmt,
        isRoundOffApplicable: Math.abs(roundOffAmt) > 0.01
      };
    })();

    const displaySubTotal = reduxTotals ? reduxTotals.itemTotal : (cartProps?.subTotal || 0);
    const displayDiscount = reduxTotals ? reduxTotals.discount : (cartProps?.resultDis || 0);
    const displayTax = reduxTotals ? reduxTotals.tax : (cartProps?.total_tax || 0);
    const displayRoundOffApplicable = reduxTotals ? reduxTotals.isRoundOffApplicable : isRoundOffApplicable;
    const displayRoundOffAmount = reduxTotals ? reduxTotals.roundOffAmount : roundOffAmount;
    const displayTotal = reduxTotals ? reduxTotals.total : (isRoundOffApplicable ? roundedTotal : (cartProps?.total || 0));

    let paymentDisplayName = "UPI";
    if (currentTndCode === "ca" || currentTndType.includes("cash") || currentTndCode === "cash") {
      paymentDisplayName = "Cash";
    } else if (currentTndCode === "pl" || currentTndType.includes("pay later") || currentTndType.includes("later")) {
      paymentDisplayName = "Pay Later";
    } else if (currentTndCode === "upi" || currentTndType.includes("upi") || currentTndType.includes("qr")) {
      paymentDisplayName = "UPI";
    } else if (currentTnd?.tnd_type) {
      paymentDisplayName = currentTnd.tnd_type;
    }

    const orderTypeName = orderPlace?.[0]?.order_type || (sessionReducer?.is_fsr ? "Dine In" : "Takeaway");

    return (
      <div style={{ backgroundColor: "#ffffff", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Navbar />

        <div style={{ flex: 1, backgroundColor: "#ffffff", width: "100%" }}>
          <Grid container style={{ minHeight: "calc(100vh - 70px)", width: "100%" }}>
            {/* LEFT COLUMN (50%): Thank You & Cooking Status */}
            <Grid item xs={12} md={6} style={{ padding: "100px 32px 20px 32px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "flex-start", textAlign: "center" }}>
                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "40px", fontWeight: "800", color: primaryColor || BUTTON_COLOR, letterSpacing: "-0.5px" }}>
                  Thank You!
                </Typography>

                <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", color: "#555555", marginTop: "40px", maxWidth: "520px", lineHeight: "1.4", fontweight: "600" }}>
                  Your order is being prepared and will be ready in 20 minutes. 
                </Typography>

                {/* Pills Row */}
                <div style={{ display: "flex", gap: "14px", marginTop: "24px", alignItems: "center" }}>
                  {orderNo && (
                    <div style={{ backgroundColor: `${primaryColor || BUTTON_COLOR}12`, borderRadius: "4px", padding: "8px 20px", display: "flex", alignItems: "center", gap: "8px" }}>
                      <OrderNoSvgIcon color={primaryColor || BUTTON_COLOR} />
                      <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "15px", fontWeight: "700", color: primaryColor || BUTTON_COLOR }}>
                        Order No: #{orderNo}
                      </Typography>
                    </div>
                  )}
                  <div style={{ backgroundColor: `${primaryColor || BUTTON_COLOR}12`, borderRadius: "4px", padding: "8px 20px", display: "flex", alignItems: "center", gap: "8px" }}>
                    <ClockSvgIcon color={primaryColor || BUTTON_COLOR} />
                    <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "15px", fontWeight: "700", color: primaryColor || BUTTON_COLOR }}>
                      ~20 min
                    </Typography>
                  </div>
                </div>

                {/* Cooking Animation / Illustration */}
                <div style={{ margin: "36px 0", display: "flex", justifyContent: "center" }}>
                  {isFSR ? (
                    <img src={FSR_OrderStatus} alt="Order Status" style={{ width: "175px", height: "175px", filter: primaryFilter, objectFit: "contain" }} />
                  ) : (
                    <svg width="175" height="168" viewBox="0 0 177 173" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22.9619 115.211C22.9714 122.409 25.835 129.309 30.9247 134.399C36.0144 139.489 42.9148 142.352 50.1127 142.362H126.474C133.672 142.352 140.572 139.489 145.662 134.399C150.752 129.309 153.615 122.409 153.625 115.211V72.5505H22.9619V115.211Z" fill={primaryColor || BUTTON_COLOR} />
                      <path d="M0.0530181 75.9444C-0.131714 78.0623 0.16775 80.1946 0.928745 82.1797C1.68974 84.1649 2.89233 85.9509 4.4455 87.4027C5.99867 88.8545 7.86172 89.9339 9.89366 90.5593C11.9256 91.1848 14.0732 91.3398 16.1739 91.0127V72.5505H3.44687C2.54758 72.5532 1.68588 72.9116 1.04998 73.5475C0.414084 74.1834 0.0556675 75.0451 0.0530181 75.9444Z" fill={primaryColor || BUTTON_COLOR} />
                      <path d="M173.138 72.5505H160.412V91.013H162.957C164.74 91.0135 166.505 90.6627 168.153 89.9807C169.8 89.2986 171.297 88.2987 172.557 87.038C173.818 85.7773 174.818 84.2806 175.5 82.6333C176.182 80.9861 176.533 79.2206 176.532 77.4377C176.808 75.0475 175.876 72.6059 173.138 72.5505Z" fill={primaryColor || BUTTON_COLOR} />
                      <path d="M61.5137 44.9638C60.9767 45.6724 60.739 46.5632 60.8515 47.4451C60.964 48.327 61.4178 49.1296 62.1155 49.6806C62.8132 50.2316 63.6991 50.487 64.583 50.3921C65.467 50.2971 66.2785 49.8594 66.8432 49.1728C69.7412 45.5177 71.2439 40.9506 71.0824 36.2888C70.9208 31.627 69.1056 27.1749 65.9615 23.7291C63.7005 21.2516 62.4984 17.9878 62.6124 14.6356C62.7264 11.2834 64.1473 8.10877 66.5713 5.79052C67.1982 5.16087 67.5532 4.31056 67.5602 3.4221C67.5672 2.53363 67.2256 1.67784 66.6087 1.03842C65.9918 0.399005 65.1488 0.0269292 64.2607 0.00206357C63.3725 -0.0228021 62.51 0.301525 61.8583 0.905425C58.1562 4.44986 55.9889 9.30285 55.8204 14.4254C55.652 19.5479 57.4957 24.5328 60.9569 28.3128C63.0108 30.5707 64.1945 33.4855 64.2965 36.536C64.3985 39.5865 63.4121 42.5738 61.5137 44.9638Z" fill={primaryColor || BUTTON_COLOR} />
                      <path d="M86.3465 44.964C85.8095 45.6725 85.5717 46.5633 85.6842 47.4452C85.7968 48.327 86.2506 49.1297 86.9483 49.6807C87.646 50.2317 88.5319 50.4871 89.4158 50.3922C90.2998 50.2973 91.1113 49.8595 91.676 49.1729C94.574 45.5178 96.0767 40.9507 95.9151 36.2889C95.7536 31.6271 93.9384 27.175 90.7943 23.7293C88.5333 21.2517 87.3312 17.988 87.4452 14.6357C87.5591 11.2835 88.9801 8.1089 91.4041 5.79064C92.0312 5.16103 92.3863 4.31066 92.3934 3.42211C92.4004 2.53355 92.0588 1.67765 91.4418 1.03817C90.8249 0.398687 89.9818 0.026607 89.0935 0.00181164C88.2053 -0.0229837 87.3427 0.301484 86.6911 0.905552C82.989 4.44999 80.8217 9.30297 80.6532 14.4255C80.4847 19.548 82.3285 24.5329 85.7897 28.3129C87.8435 30.5707 89.0272 33.4856 89.1293 36.5361C89.2313 39.5866 88.2449 42.5739 86.3465 44.964Z" fill={primaryColor || BUTTON_COLOR} />
                      <path d="M111.178 44.9639C110.641 45.6724 110.403 46.5632 110.515 47.4451C110.628 48.327 111.082 49.1296 111.779 49.6806C112.477 50.2316 113.363 50.487 114.247 50.3921C115.131 50.2972 115.942 49.8594 116.507 49.1728C119.406 45.5181 120.909 40.9512 120.748 36.2894C120.587 31.6276 118.772 27.1753 115.629 23.7292C113.368 21.2516 112.166 17.9878 112.28 14.6356C112.394 11.2834 113.815 8.10878 116.239 5.79053C116.866 5.16095 117.221 4.31053 117.228 3.42188C117.235 2.53323 116.894 1.67722 116.277 1.03768C115.66 0.398127 114.816 0.02604 113.928 0.00131552C113.04 -0.0234089 112.177 0.301202 111.526 0.905439C107.823 4.44988 105.656 9.30287 105.488 14.4254C105.319 19.5479 107.163 24.5328 110.624 28.3128C112.678 30.5711 113.861 33.4861 113.962 36.5366C114.064 39.5871 113.077 42.5742 111.178 44.9639Z" fill={primaryColor || BUTTON_COLOR} />
                      <path d="M144.169 166.189H132.413V156.959C132.413 156.059 132.055 155.196 131.419 154.559C130.782 153.923 129.919 153.565 129.019 153.565C128.119 153.565 127.256 153.923 126.619 154.559C125.983 155.196 125.625 156.059 125.625 156.959V166.189H91.6868V156.008C91.6696 155.119 91.3045 154.272 90.6698 153.65C90.0352 153.027 89.1818 152.679 88.2928 152.679C87.4039 152.679 86.5505 153.028 85.9159 153.65C85.2813 154.273 84.9163 155.119 84.8991 156.008V166.189H50.9607V156.008C50.9607 155.108 50.6032 154.244 49.9667 153.608C49.3302 152.971 48.467 152.614 47.5669 152.614C46.6668 152.614 45.8035 152.971 45.1671 153.608C44.5306 154.244 44.173 155.108 44.173 156.008V166.189H32.4172C31.526 166.203 30.6758 166.566 30.0503 167.201C29.4248 167.836 29.0742 168.692 29.0742 169.583C29.0742 170.474 29.4248 171.33 30.0503 171.965C30.6758 172.6 31.526 172.963 32.4172 172.977H144.169C145.057 172.959 145.903 172.593 146.524 171.959C147.146 171.324 147.494 170.471 147.494 169.583C147.494 168.695 147.146 167.842 146.524 167.207C145.903 166.573 145.057 166.207 144.169 166.189Z" fill={primaryColor || BUTTON_COLOR} />
                    </svg>
                  )}
                </div>

                {/* Order Again Button */}
                <Button
                  variant="contained"
                  onClick={handleClearStorage}
                  style={{
                    backgroundColor: primaryColor || BUTTON_COLOR,
                    color: "#ffffff",
                    width: "100%",
                    maxWidth: "360px",
                    height: "48px",
                    borderRadius: "8px",
                    fontSize: "16px",
                    fontWeight: "700",
                    fontFamily: "Satoshi, sans-serif",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                >
                  Order Again
                </Button>

                {/* Contact Us & Need Help */}
                <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span
                    onClick={() => navigate("/contactus")}
                    style={{
                      fontFamily: "Satoshi, sans-serif",
                      fontSize: "13px",
                      fontWeight: "700",
                      color: primaryColor || BUTTON_COLOR,
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Contact us
                  </span>
                  <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "12px", color: "#8E8E93", marginTop: "2px" }}>
                    Need help?
                  </span>
                </div>
              </Grid>

              {/* RIGHT COLUMN (50%): Order Receipt & Details */}
              <Grid item xs={12} md={6} style={{ padding: "36px 36px 32px 36px", borderLeft: "1px solid #F2F2F7", display: "flex", flexDirection: "column", gap: "18px" }}>
                {/* Store Header & Download Invoice Button */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <img
                      src={storeLogo}
                      alt="Store Logo"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = defaultimg;
                      }}
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "8px",
                        objectFit: "cover",
                        marginLeft: "-2px",
                        flexShrink: 0,
                      }}
                    />
                    <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", fontWeight: "700", color: primaryColor || BUTTON_COLOR }}>
                      {storeName}
                    </Typography>
                  </div>

                  <Button
                    variant="outlined"
                    onClick={handleDownload}
                    disabled={downloading}
                    style={{
                      borderColor: primaryColor || BUTTON_COLOR,
                      color: primaryColor || BUTTON_COLOR,
                      borderRadius: "4px",
                      fontSize: "13px",
                      fontWeight: "700",
                      fontFamily: "Satoshi, sans-serif",
                      textTransform: "none",
                      padding: "6px 14px",
                      height: "36px",
                    }}
                    startIcon={downloading ? <CircularProgress size={16} style={{ color: primaryColor }} /> : <DownloadIcon style={{ fontSize: "18px" }} />}
                  >
                    Download Invoice
                  </Button>
                </div>

                <div style={{ height: "1px", backgroundColor: "#F2F2F7", margin: "2px 0" }} />

                {/* Ordered Items List */}
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {visibleItems.map((t, idx) => {
                    const dietaryIcon = getDietaryIcon(t);

                    const modifiers = (t?.selected_modifier || t?.selectedModifier || []).flatMap((sm) => {
                      if (Array.isArray(sm?.modifiers)) {
                        return sm.modifiers.map((m) => m?.modifier_name || m?.name).filter(Boolean);
                      }
                      return [sm?.modifier_name || sm?.name].filter(Boolean);
                    });

                    const addonsList = t?.subItems?.length ? t.subItems : (t?.selectedAddonsItems || t?.selected_addons_items || []);
                    const addons = addonsList
                      .map((a) => (a?.item_name || a?.name || a?.item_variant?.[0]?.item_name || "").replace(/\s*Regular\b/gi, "").trim())
                      .filter(Boolean);

                    const modifiersText = [...modifiers, ...addons]
                      .filter(Boolean)
                      .map((n) => n.trim())
                      .filter((n) => n !== "")
                      .join(", ");

                    return (
                      <div key={idx} style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "8px", flex: 1, minWidth: 0, paddingRight: "12px" }}>
                          {dietaryIcon ? (
                            <img src={dietaryIcon} alt="dietary" style={{ width: "15px", height: "15px", flexShrink: 0, marginTop: "3px" }} />
                          ) : (
                            <div style={{ width: "15px", height: "15px", flexShrink: 0, marginTop: "3px" }} />
                          )}
                          <div style={{ display: "flex", flexDirection: "column", gap: "2px", textAlign: "left" }}>
                            <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "15px", fontWeight: "600", color: "#333333" }}>
                              {t.quantity} X {t.item_name}
                            </Typography>
                            {modifiersText && (
                              <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "12px", color: "#8E8E93", lineHeight: "1.3" }}>
                                {modifiersText}
                              </Typography>
                            )}
                          </div>
                        </div>
                        <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "15px", fontWeight: "700", color: primaryColor || BUTTON_COLOR, flexShrink: 0 }}>
                          {currency}{formatPrice(isFSR ? getCumulativePrice(t, t.subItems) : t.sub_total)}
                        </Typography>
                      </div>
                    );
                  })}

                  {allItems.length > 3 && (
                    <span
                      onClick={() => setShowAllItems(!showAllItems)}
                      style={{
                        fontFamily: "Satoshi, sans-serif",
                        fontSize: "13px",
                        fontWeight: "700",
                        color: primaryColor || BUTTON_COLOR,
                        cursor: "pointer",
                        textDecoration: "underline",
                        textAlign: "left",
                        marginTop: "4px",
                      }}
                    >
                      {showAllItems ? "Show less" : `& ${remainingCount} more items`}
                    </span>
                  )}
                </div>

                <div style={{ height: "1px", backgroundColor: "#F2F2F7", margin: "2px 0" }} />

                {/* Price Breakdown */}
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", color: "#666666", fontWeight: "500" }}>Item Total</span>
                    <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "600", color: "#333333" }}>{currency}{formatPrice(displaySubTotal)}</span>
                  </div>
                  {displayDiscount > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", color: "#666666", fontWeight: "500" }}>Discount</span>
                      <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "600", color: primaryColor || BUTTON_COLOR }}>- {currency}{formatPrice(displayDiscount)}</span>
                    </div>
                  )}
                  {displayTax > 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", color: "#666666", fontWeight: "500" }}>Tax</span>
                      <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "600", color: "#333333" }}>{currency}{formatPrice(displayTax)}</span>
                    </div>
                  )}
                  {displayRoundOffApplicable && displayRoundOffAmount !== 0 && (
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", color: "#666666", fontWeight: "500" }}>Round Off</span>
                      <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "600", color: "#333333" }}>{formatRoundOff(displayRoundOffAmount)}</span>
                    </div>
                  )}
                </div>

                <div style={{ height: "1px", backgroundColor: "#F2F2F7", margin: "2px 0" }} />

                {/* Grand Total Row */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "18px", fontWeight: "700", color: "#1A1A1A" }}>Total</span>
                  <span style={{ fontFamily: "Satoshi, sans-serif", fontSize: "20px", fontWeight: "700", color: "#1A1A1A" }}>{currency}{displayTotal.toFixed(2)}</span>
                </div>

                {/* Payment Method & Order Type Cards */}
                <div style={{ display: "flex", flexDirection: "column", gap: "14px", marginTop: "10px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: `${primaryColor || BUTTON_COLOR}12`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <PaymentMethodsIcon primaryColor={primaryColor || BUTTON_COLOR} />
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "700", color: "#1A1A1A" }}>
                        Payment Method
                      </Typography>
                      <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "13px", fontWeight: "600", color: primaryColor || BUTTON_COLOR }}>
                        Paid via: {paymentDisplayName}
                      </Typography>
                    </div>
                  </div>

                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ width: "40px", height: "40px", borderRadius: "50%", backgroundColor: `${primaryColor || BUTTON_COLOR}12`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <OTStatusIcon primaryColor={primaryColor || BUTTON_COLOR} />
                    </div>
                    <div style={{ textAlign: "left" }}>
                      <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "14px", fontWeight: "700", color: "#1A1A1A" }}>
                        Order Type
                      </Typography>
                      <Typography style={{ fontFamily: "Satoshi, sans-serif", fontSize: "13px", fontWeight: "600", color: primaryColor || BUTTON_COLOR }}>
                        {orderTypeName}
                      </Typography>
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
        </div>
      </div>
    );
  }

  return storeInfo?._id ? (
    <Grid style={{ height: "100dvh", backgroundColor: "#ffffff", display: "flex", flexDirection: "column" }}>
      {/* {isAnimationActive ? <Confetti width={width} height={400} /> : null} */}

      {/* Main Scrollable Content Area */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          scrollbarWidth: "none",
          backgroundColor: "#ffffff",
          paddingBottom: "24px",
        }}
      >
        {/* Thank You Title */}
        {!isFSR && (
          <Typography
            style={{
              textAlign: "center",
              marginTop: "40px",
              fontSize: "32px",
              fontWeight: "800",
              fontFamily: "Satoshi",
              color: primaryColor || BUTTON_COLOR,
            }}
          >
            <span style={{fontSize:"32px"}}>Thank You!</span>
          </Typography>
        )}

        {!isFSR && (
          <Typography
            style={{
              textAlign: "center",
              fontFamily: "Satoshi",
              color: "#4B4A4B",
              fontSize: "16px",
              marginTop: "12px",
              padding: "0 24px",
              lineHeight: "1.4",
            }}
          >
            Your order is being prepared and will be ready in 20 minutes.
          </Typography>
        )}

        {/* Order No */}
        {!isFSR && (
          <Typography style={{ textAlign: "center", marginTop: "20px", marginBottom: "20px", color: primaryColor || BUTTON_COLOR, fontFamily: "Satoshi" }}>
            <span style={{ fontSize: "18px", fontWeight: "700" }}>Order No: </span>
            <span style={{ fontSize: "20px", fontWeight: "700" }}>
              #{orderPlace?.[0]?.invoice_no}
            </span>
          </Typography>
        )}

        {/* SVG Centered Container */}
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: isFSR ? "60px" : "20px", marginBottom: "30px" }}>
          {isFSR ? (
            <>
              <img
                src={FSR_OrderStatus}
                alt="Order Status"
                style={{
                  width: "177px",
                  height: "173px",
                  filter: primaryFilter,
                  objectFit: "contain",
                }}
              />
              <Typography
                style={{
                  textAlign: "center",
                  marginTop: "24px",
                  fontSize: "32px",
                  fontWeight: "800",
                  fontFamily: "Satoshi",
                  color: primaryColor || BUTTON_COLOR,
                }}
              >
                <span style={{fontSize:"32px"}}>Thank You!</span>
              </Typography>
            </>
          ) : (
            <svg
              width="177"
              height="173"
              viewBox="0 0 177 173"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.9619 115.211C22.9714 122.409 25.835 129.309 30.9247 134.399C36.0144 139.489 42.9148 142.352 50.1127 142.362H126.474C133.672 142.352 140.572 139.489 145.662 134.399C150.752 129.309 153.615 122.409 153.625 115.211V72.5505H22.9619V115.211Z"
                fill={primaryColor || BUTTON_COLOR}
              />
              <path
                d="M0.0530181 75.9444C-0.131714 78.0623 0.16775 80.1946 0.928745 82.1797C1.68974 84.1649 2.89233 85.9509 4.4455 87.4027C5.99867 88.8545 7.86172 89.9339 9.89366 90.5593C11.9256 91.1848 14.0732 91.3398 16.1739 91.0127V72.5505H3.44687C2.54758 72.5532 1.68588 72.9116 1.04998 73.5475C0.414084 74.1834 0.0556675 75.0451 0.0530181 75.9444Z"
                fill={primaryColor || BUTTON_COLOR}
              />
              <path
                d="M173.138 72.5505H160.412V91.013H162.957C164.74 91.0135 166.505 90.6627 168.153 89.9807C169.8 89.2986 171.297 88.2987 172.557 87.038C173.818 85.7773 174.818 84.2806 175.5 82.6333C176.182 80.9861 176.533 79.2206 176.532 77.4377C176.808 75.0475 175.876 72.6059 173.138 72.5505Z"
                fill={primaryColor || BUTTON_COLOR}
              />
              <path
                d="M61.5137 44.9638C60.9767 45.6724 60.739 46.5632 60.8515 47.4451C60.964 48.327 61.4178 49.1296 62.1155 49.6806C62.8132 50.2316 63.6991 50.487 64.583 50.3921C65.467 50.2971 66.2785 49.8594 66.8432 49.1728C69.7412 45.5177 71.2439 40.9506 71.0824 36.2888C70.9208 31.627 69.1056 27.1749 65.9615 23.7291C63.7005 21.2516 62.4984 17.9878 62.6124 14.6356C62.7264 11.2834 64.1473 8.10877 66.5713 5.79052C67.1982 5.16087 67.5532 4.31056 67.5602 3.4221C67.5672 2.53363 67.2256 1.67784 66.6087 1.03842C65.9918 0.399005 65.1488 0.0269292 64.2607 0.00206357C63.3725 -0.0228021 62.51 0.301525 61.8583 0.905425C58.1562 4.44986 55.9889 9.30285 55.8204 14.4254C55.652 19.5479 57.4957 24.5328 60.9569 28.3128C63.0108 30.5707 64.1945 33.4855 64.2965 36.536C64.3985 39.5865 63.4121 42.5738 61.5137 44.9638Z"
                fill={primaryColor || BUTTON_COLOR}
              />
              <path
                d="M86.3465 44.964C85.8095 45.6725 85.5717 46.5633 85.6842 47.4452C85.7968 48.327 86.2506 49.1297 86.9483 49.6807C87.646 50.2317 88.5319 50.4871 89.4158 50.3922C90.2998 50.2973 91.1113 49.8595 91.676 49.1729C94.574 45.5178 96.0767 40.9507 95.9151 36.2889C95.7536 31.6271 93.9384 27.175 90.7943 23.7293C88.5333 21.2517 87.3312 17.988 87.4452 14.6357C87.5591 11.2835 88.9801 8.1089 91.4041 5.79064C92.0312 5.16103 92.3863 4.31066 92.3934 3.42211C92.4004 2.53355 92.0588 1.67765 91.4418 1.03817C90.8249 0.398687 89.9818 0.026607 89.0935 0.00181164C88.2053 -0.0229837 87.3427 0.301484 86.6911 0.905552C82.989 4.44999 80.8217 9.30297 80.6532 14.4255C80.4847 19.548 82.3285 24.5329 85.7897 28.3129C87.8435 30.5707 89.0272 33.4856 89.1293 36.5361C89.2313 39.5866 88.2449 42.5739 86.3465 44.964Z"
                fill={primaryColor || BUTTON_COLOR}
              />
              <path
                d="M111.178 44.9639C110.641 45.6724 110.403 46.5632 110.515 47.4451C110.628 48.327 111.082 49.1296 111.779 49.6806C112.477 50.2316 113.363 50.487 114.247 50.3921C115.131 50.2972 115.942 49.8594 116.507 49.1728C119.406 45.5181 120.909 40.9512 120.748 36.2894C120.587 31.6276 118.772 27.1753 115.629 23.7292C113.368 21.2516 112.166 17.9878 112.28 14.6356C112.394 11.2834 113.815 8.10878 116.239 5.79053C116.866 5.16095 117.221 4.31053 117.228 3.42188C117.235 2.53323 116.894 1.67722 116.277 1.03768C115.66 0.398127 114.816 0.02604 113.928 0.00131552C113.04 -0.0234089 112.177 0.301202 111.526 0.905439C107.823 4.44988 105.656 9.30287 105.488 14.4254C105.319 19.5479 107.163 24.5328 110.624 28.3128C112.678 30.5711 113.861 33.4861 113.962 36.5366C114.064 39.5871 113.077 42.5742 111.178 44.9639Z"
                fill={primaryColor || BUTTON_COLOR}
              />
              <path
                d="M144.169 166.189H132.413V156.959C132.413 156.059 132.055 155.196 131.419 154.559C130.782 153.923 129.919 153.565 129.019 153.565C128.119 153.565 127.256 153.923 126.619 154.559C125.983 155.196 125.625 156.059 125.625 156.959V166.189H91.6868V156.008C91.6696 155.119 91.3045 154.272 90.6698 153.65C90.0352 153.027 89.1818 152.679 88.2928 152.679C87.4039 152.679 86.5505 153.028 85.9159 153.65C85.2813 154.273 84.9163 155.119 84.8991 156.008V166.189H50.9607V156.008C50.9607 155.108 50.6032 154.244 49.9667 153.608C49.3302 152.971 48.467 152.614 47.5669 152.614C46.6668 152.614 45.8035 152.971 45.1671 153.608C44.5306 154.244 44.173 155.108 44.173 156.008V166.189H32.4172C31.526 166.203 30.6758 166.566 30.0503 167.201C29.4248 167.836 29.0742 168.692 29.0742 169.583C29.0742 170.474 29.4248 171.33 30.0503 171.965C30.6758 172.6 31.526 172.963 32.4172 172.977H144.169C145.057 172.959 145.903 172.593 146.524 171.959C147.146 171.324 147.494 170.471 147.494 169.583C147.494 168.695 147.146 167.842 146.524 167.207C145.903 166.573 145.057 166.207 144.169 166.189Z"
                fill={primaryColor || BUTTON_COLOR}
              />
            </svg>
          )}
        </div>
        {/* Cash Counter Instruction Card */}
        {(isFSR || isCashOrPayLater()) && (
          <Grid style={{ padding: "0 16px", marginBottom: "30px" }}>
          <Box
            style={{
              backgroundColor: `${primaryColor}26`,
              marginTop: "16px",
              padding: "24px 21px",
              borderRadius: "8px",
              textAlign: "center",
            }}
          >
              <Typography
                style={{
                  fontFamily: "Satoshi",
                  fontSize: "15px",
                  fontWeight: "500",
                  color: "#4B4A4B",
                  lineHeight: "1.5",
                }}
              >
                {isFSR
                  ? "We appreciate your visit and hope you had a wonderful experience. Thank you for choosing us."
                  : "Please proceed to the cash counter to complete your payment."}
              </Typography>
            </Box>
          </Grid>
        )}

        {/* Expandable Order List & Prices Container */}
        <Box
          style={{
            margin: "0 16px",
            backgroundColor: "#ffffff",
          }}
        >
          <Grid
            container
            alignItems="center"
            style={{
              padding: "8px 12px",
              border: `1px solid ${primaryColor || BUTTON_COLOR}`,
              borderRadius: "8px",
              cursor: "pointer",
              backgroundColor: "#ffffff",
              display: "flex",
              justifyContent: "space-between",
            }}
            onClick={handleCollapse}
          >
            <Grid item style={{ 
              flex: 1, 
              display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
              <Typography
                style={{
                  fontFamily: "Satoshi",
                  fontWeight: "700",
                  fontSize: "15px",
                  color: primaryColor || BUTTON_COLOR,
                  whiteSpace: "nowrap",
                }}
              >
                Order List & Prices
              </Typography>
            </Grid>
            <Grid item style={{ 
              display: "flex",marginRight:"12px",
               justifyContent: "center", alignItems: "center" }}>
              {isCollapsed ? (
                <KeyboardArrowDownIcon style={{ fontSize: "34px", color: primaryColor || BUTTON_COLOR }} />
              ) : (
                <KeyboardArrowUpIcon style={{ fontSize: "34px", color: primaryColor || BUTTON_COLOR }} />
              )}
            </Grid>
            <Grid item style={{ 
              // flex: 1, 
              display: "flex", 
              justifyContent: "flex-end", alignItems: "center" }}>
              <Box
                onClick={handleDownload}
                style={{
                  backgroundColor: primaryColor || BUTTON_COLOR,
                  color: "#ffffff",
                  borderRadius: "2px",
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                {downloading ? (
                  <CircularProgress size={16} style={{ color: "#ffffff" }} />
                ) : (
                  <DownloadIcon style={{ fontSize: "18px", color: "#ffffff" }} />
                )}
              </Box>
            </Grid>
          </Grid>
          {!isCollapsed && (() => {
            const storeName = orderPlace?.[0]?.store_details?.store_name || storeInfo?.store_name || "Casa Carne";
            const storeLogo = orderPlace?.[0]?.store_details?.store_logo || orderPlace?.[0]?.store_details?.store_display_logo || storeInfo?.store_display_logo || defaultimg;
            const orderNo = orderPlace?.[0]?.invoice_no || "";
            const isFSR = getFSRStatus();
            const allItems = (orderPlace || []).flatMap(item => 
              isFSR 
                ? groupItems(item?.item_details)
                : (item?.item_details || []).filter(t => !t?.main_item_id)
            );
            const visibleItems = showAllItems ? allItems : allItems.slice(0, 3);
            const remainingCount = allItems.length - 3;
            const roundOffSetting = storeInfoConfig?.general_config?.round_off;
            const configApplyFor = (storeInfoConfig?.general_config?.apply_for || "").toLowerCase();
            const configPaymentTypes = storeInfoConfig?.general_config?.payment_types || storeInfoConfig?.general_config?.round_off_payments;

            const currentTnd = orderPlace?.[0]?.payment_details?.[0] || selectedTender;
            const currentTndType = (currentTnd?.tnd_type || "").toLowerCase();
            const currentTndCode = (currentTnd?.tnd_code || "").toLowerCase();

            let paymentDisplayName = "Payment Method";
            if (currentTndCode === "ca" || currentTndType.includes("cash") || currentTndCode === "cash") {
              paymentDisplayName = "Cash";
            } else if (currentTndCode === "pl" || currentTndType.includes("pay later") || currentTndType.includes("later")) {
              paymentDisplayName = "Pay Later";
            } else if (currentTndCode === "upi" || currentTndType.includes("upi") || currentTndType.includes("qr")) {
              paymentDisplayName = "UPI";
            } else {
              const rawName = currentTnd?.tnd_type || currentTnd?.tnd_code || "Payment Method";
              paymentDisplayName = rawName.charAt(0).toUpperCase() + rawName.slice(1);
            }

            let isRoundOffApplicable = false;

            if (roundOffSetting === true || roundOffSetting === "true") {
              if (configApplyFor.includes("cash only")) {
                isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
              } else if (configApplyFor.includes("selected payments") || Array.isArray(configPaymentTypes)) {
                if (Array.isArray(configPaymentTypes)) {
                  isRoundOffApplicable = configPaymentTypes.some(item => {
                    if (typeof item === "string") {
                      const itemLower = item.toLowerCase();
                      return currentTndType === itemLower || currentTndCode === itemLower || currentTndType.includes(itemLower);
                    }
                    if (typeof item === "object" && item) {
                      const itemType = (item.tnd_type || item.type || "").toLowerCase();
                      const itemCode = (item.tnd_code || item.code || "").toLowerCase();
                      return currentTndType === itemType || currentTndCode === itemCode || (itemType && currentTndType.includes(itemType));
                    }
                    return false;
                  });
                } else {
                  isRoundOffApplicable = currentTndType.includes("cash") || currentTndCode === "cash";
                }
              } else {
                isRoundOffApplicable = true;
              }
            }

            const roundOffType = (storeInfoConfig?.general_config?.type || storeInfoConfig?.general_config?.round_off_type || "nearest").toLowerCase();
            const rawTotal = cartProps?.total + cartProps?.total_tax + (cartProps?.tip || 0);
            let roundedTotal = rawTotal;
            if (isRoundOffApplicable) {
              if (roundOffType === "up") {
                roundedTotal = Math.ceil(rawTotal);
              } else if (roundOffType === "down") {
                roundedTotal = Math.floor(rawTotal);
              } else {
                roundedTotal = Math.round(rawTotal);
              }
            }
            const roundOffAmount = roundedTotal - rawTotal;

            const formatRoundOff = (val) => {
              if (val === 0) return "0.00";
              const formatted = Math.abs(val).toFixed(2);
              return val > 0 ? `+${currency} ${formatted}` : `-${currency} ${formatted}`;
            };

            // Recalculated values from Redux response
            const reduxTotals = (() => {
              const targetOrder = orderPlace?.[0];
              if (!targetOrder) return null;
              
              // Prefer engine-calculated base (tax-exclusive) sub_total
              const itemTotal = parseFloat(targetOrder.sub_total ?? targetOrder.total_item_price ?? 0);
              const tax = parseFloat(targetOrder.total_item_tax || 0);
              const discount = parseFloat(targetOrder.total_discount || 0);
              let finalTotal = parseFloat(targetOrder.rounded_total || targetOrder.transaction_grand_amount || targetOrder.grand_total || 0);
              let roundOffAmt = parseFloat(targetOrder.round_off_amount || 0);

              // If the backend didn't update the root level totals, pull them from the latest payment_details
              if (targetOrder.payment_details && targetOrder.payment_details.length > 0) {
                 const pd = targetOrder.payment_details[0];
                 if (pd.round_off_amount !== undefined && pd.round_off_amount !== 0) {
                     roundOffAmt = parseFloat(pd.round_off_amount);
                     // If there's a round off, the final total is exactly the amount paid
                     finalTotal = parseFloat(pd.amount || finalTotal);
                 }
              }

              return {
                itemTotal,
                tax,
                discount,
                total: finalTotal,
                roundOffAmount: roundOffAmt,
                isRoundOffApplicable: Math.abs(roundOffAmt) > 0.01
              };
            })();

            const displaySubTotal = reduxTotals ? reduxTotals.itemTotal : (cartProps?.subTotal || 0);
            const displayTip = reduxTotals ? parseFloat(orderPlace?.[0]?.tip_amount || 0) : (cartProps?.tip || 0);
            const displayDiscount = reduxTotals ? reduxTotals.discount : (cartProps?.resultDis || 0);
            const displayChargesTitle = reduxTotals ? null : cartProps?.chargesTitle;
            const displayChargeValue = reduxTotals ? parseFloat(orderPlace?.[0]?.additional_charges || 0) : (cartProps?.chargeValue || 0);
            const displayTax = reduxTotals ? reduxTotals.tax : (cartProps?.total_tax || 0);
            const displayRoundOffApplicable = reduxTotals ? reduxTotals.isRoundOffApplicable : isRoundOffApplicable;
            const displayRoundOffAmount = reduxTotals ? reduxTotals.roundOffAmount : roundOffAmount;
            const displayTotal = reduxTotals ? reduxTotals.total : roundedTotal;
            
            return (
              <>
                {/* Card 1: Order details & Prices */}
                <Box
                  ref={orderListContentRef}
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    border: "1px solid #f1f5f9",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.04)",
                    padding: "16px",
                    marginTop: "12px",
                  }}
                >
                  {/* Card 1 Header */}
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: "16px",
                    }}
                  >
                    <Box style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      {/* <img
                        src={storeLogo}
                        alt="Store Logo"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultimg;
                        }}
                        style={{
                          width: "50px",
                          height: "50px",
                          borderRadius: "2px",
                          objectFit: "cover",
                        }}
                      /> */}
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "20px",
                          color: primaryColor || BUTTON_COLOR,
                        }}
                      >
                       <span style={{fontSize:'18px'}}>{storeName}</span>
                      </Typography>
                    </Box>
                    {orderNo && (
                      <Box
                        style={{
                          backgroundColor: `rgba(${hexToRgb(primaryColor || BUTTON_COLOR)}, 0.08)`,
                          borderRadius: "8px",
                          padding: "6px 12px",
                        }}
                      >
                        <Typography
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "14px",
                            color: primaryColor || BUTTON_COLOR,
                          }}
                        >
                         <span style={{fontSize:'16px'}}>Order No. {orderNo}</span> 
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  {/* Item List */}
                  <Box style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                    {visibleItems.map((t, idx) => {
                      const dietaryIcon = getDietaryIcon(t);
                      return (
                        <Box key={idx} style={{ display: "flex", flexDirection: "column" }}>
                          <Box
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box style={{ display: "flex", alignItems: "flex-start", gap: "8px", maxWidth: "calc(100% - 100px)" }}>
                              {dietaryIcon && (
                                <img
                                  src={dietaryIcon}
                                  alt="Dietary Icon"
                                  style={{ width: "16px", height: "16px", marginTop: "3px", flexShrink: 0 }}
                                />
                              )}
                              <Typography
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "700",
                                  fontSize: "15px",
                                  color: "#333333",
                                  textAlign: "left",
                                  flex: 1,
                                  minWidth: 0,
                                }}
                              >
                              <span style={{fontSize:'16px'}}>{t.quantity} X {t.item_name}</span>
                              </Typography>
                            </Box>
                            <Typography
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "700",
                                fontSize: "18px",
                                color: primaryColor || BUTTON_COLOR,
                                paddingRight: "12px",
                                marginTop: "2px",
                                flexShrink: 0,
                              }}
                            >
                              <span style={{fontSize:'18px'}}>
                              {currency}{" "}
                              {formatPrice(isFSR ? getCumulativePrice(t, t.subItems) : t.sub_total)}
                              </span>
                            </Typography>
                          </Box>
                          {/* Modifiers & Addons if any */}
                          {(() => {
                            let addonsText = "";
                            if (isFSR) {
                              const modifiersList = [];
                              if (t?.selected_modifier) {
                                t.selected_modifier.forEach(sm => {
                                  sm?.modifiers?.forEach(m => {
                                    if (m?.modifier_name) modifiersList.push(m.modifier_name);
                                  });
                                });
                              }

                              const groupedAddons = {};
                              const registerAddon = (name, variant) => {
                                if (!name) return;
                                const baseName = name.trim();
                                const varName = (variant || "").trim();
                                if (!groupedAddons[baseName]) {
                                  groupedAddons[baseName] = new Set();
                                }
                                if (varName && varName.toLowerCase() !== "regular") {
                                  groupedAddons[baseName].add(varName);
                                }
                              };

                              const processAddonItem = (addon) => {
                                if (!addon) return;
                                const name = addon.item_name || addon.name || addon.item_variant?.[0]?.item_name;
                                const variant = addon.variant_name || addon.item_variant?.[0]?.variant_name;
                                registerAddon(name, variant);
                              };

                              if (t?.selectedAddonsItems) t.selectedAddonsItems.forEach(processAddonItem);
                              if (t?.selected_addons_items) t.selected_addons_items.forEach(processAddonItem);
                              if (t?.subItems) t.subItems.forEach(processAddonItem);

                              Object.keys(groupedAddons).forEach(baseName => {
                                const variantsSet = groupedAddons[baseName];
                                if (variantsSet.size > 0) {
                                  const variantsString = Array.from(variantsSet).join(", ");
                                  modifiersList.push(`${baseName} - ${variantsString}`);
                                } else {
                                  modifiersList.push(baseName);
                                }
                              });

                              addonsText = modifiersList
                                .filter(Boolean)
                                .map(name => name.replace(/\s*Regular\b/i, ""))
                                .filter((value, index, self) => self.indexOf(value) === index)
                                .join(", ");
                            } else {
                              const modifiersList = [];
                              if (t?.selected_modifier) {
                                t.selected_modifier.forEach(sm => {
                                  sm?.modifiers?.forEach(m => {
                                    if (m?.modifier_name) modifiersList.push(m.modifier_name);
                                  });
                                });
                              }

                              const groupedAddons = {};
                              const registerAddon = (name, variant) => {
                                if (!name) return;
                                const baseName = name.trim();
                                const varName = (variant || "").trim();
                                if (!groupedAddons[baseName]) {
                                  groupedAddons[baseName] = new Set();
                                }
                                if (varName && varName.toLowerCase() !== "regular") {
                                  groupedAddons[baseName].add(varName);
                                }
                              };

                              const processAddonItem2 = (addon) => {
                                if (!addon) return;
                                const name = addon.item_name || addon.name || addon.item_variant?.[0]?.item_name;
                                const variant = addon.variant_name || addon.item_variant?.[0]?.variant_name;
                                registerAddon(name, variant);
                              };

                              if (t?.selectedAddonsItems) t.selectedAddonsItems.forEach(processAddonItem2);
                              if (t?.selected_addons_items) t.selected_addons_items.forEach(processAddonItem2);
                              if (t?.subItems) t.subItems.forEach(processAddonItem2);

                              Object.keys(groupedAddons).forEach(baseName => {
                                const variantsSet = groupedAddons[baseName];
                                if (variantsSet.size > 0) {
                                  const variantsString = Array.from(variantsSet).join(", ");
                                  modifiersList.push(`${baseName} - ${variantsString}`);
                                } else {
                                  modifiersList.push(baseName);
                                }
                              });

                              addonsText = modifiersList
                                .filter(Boolean)
                                .map(name => name.replace(/\s*Regular\b/i, ""))
                                .filter((value, index, self) => self.indexOf(value) === index)
                                .join(", ");
                            }

                            if (!addonsText) return null;

                            return (
                              <Box style={{ paddingLeft: "24px", marginTop: "2px", maxWidth: "calc(100% - 100px)" }}>
                                <Typography
                                  style={{
                                    fontFamily: "Satoshi",
                                    fontSize: "12px",
                                    color: "#666666",
                                    textAlign: "left",
                                  }}
                                >
                                  {addonsText}
                                </Typography>
                              </Box>
                            );
                          })()}
                        </Box>
                      );
                    })}
                  </Box>

                  {/* Expand/Collapse more items link */}
                  {allItems.length > 3 && (
                    <Box style={{ marginTop: "8px", paddingLeft: "24px", display: "flex", justifyContent: "flex-start" }}>
                      <Typography
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowAllItems(!showAllItems);
                        }}
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          color: primaryColor || BUTTON_COLOR,
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                      >
                        {showAllItems ? "Show less" : `& ${remainingCount} more items`}
                      </Typography>
                    </Box>
                  )}

                  <div style={{ height: "1px", backgroundColor: "#f1f5f9", margin: "16px 0" }} />

                  {/* Price Breakdown */}
                  <Box style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <Box style={{ display: "flex", justifyContent: "space-between" }}>
                      <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#666666", paddingLeft: "24px" }}>
                        <span style={{fontSize:"18px", fontWeight: "600", color: "#333333"}}>Item Total</span>
                      </Typography>
                      <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#333333", paddingRight: "12px" }}>
                          <span style={{fontSize:"18px"}}>{currency} {formatPrice(displaySubTotal)}</span>
                      </Typography>
                    </Box>

                    {tip_enable && displayTip > 0 && (
                      <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#666666", paddingLeft: "24px" }}>
                          <span style={{fontSize:"18px", fontWeight: "600", color: "#333333"}}>Tip</span>
                        </Typography>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#333333", paddingRight: "12px" }}>
                          <span style={{fontSize:"18px"}}> {currency}{" "}
                          {formatPrice(displayTip)}</span>
                        </Typography>
                      </Box>
                    )}

                    {displayDiscount > 0 && (
                      <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#666666", paddingLeft: "24px" }}>
                          <span style={{fontSize:"18px", fontWeight: "600", color: "#333333"}}>Discount</span>
                        </Typography>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#e53e3e", paddingRight: "12px" }}>
                          <span style={{fontSize:"18px"}}>-{currency} {formatPrice(displayDiscount)}</span>
                        </Typography>
                      </Box>
                    )}

                    {displayChargesTitle && displayChargeValue > 0 && (
                      <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#666666", paddingLeft: "24px" }}>
                          <span style={{fontSize:"18px", fontWeight: "600", color: "#333333"}}>{displayChargesTitle}</span>
                        </Typography>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#333333", paddingRight: "12px" }}>
                          <span style={{fontSize:"18px"}}>{currency}{" "}</span>
                          <span style={{fontSize:"18px"}}>{formatPrice(displayChargeValue)}</span>
                        </Typography>
                      </Box>
                    )}

                    {displayTax > 0 && (
                      <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#666666", paddingLeft: "24px" }}>
                          <span style={{fontSize:"18px",fontWeight: "600", color: "#333333"}}>Tax</span>
                        </Typography>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#333333", paddingRight: "12px" }}>
                          <span style={{fontSize:"18px"}}>{currency}{" "}</span>
                          <span style={{fontSize:"18px"}}>{formatPrice(displayTax)}</span>
                        </Typography>
                      </Box>
                    )}

                    {displayRoundOffApplicable && displayRoundOffAmount !== 0 && (
                      <Box style={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", color: "#666666", paddingLeft: "24px" }}>
                          <span style={{fontSize:"18px", fontWeight: "600", color: "#333333"}}>Round Off</span>
                        </Typography>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "14px", fontWeight: "600", color: "#333333", paddingRight: "12px" }}>
                          <span style={{fontSize:"18px"}}>{formatRoundOff(displayRoundOffAmount)}</span>
                        </Typography>
                      </Box>
                    )}
                  </Box>

                  <div style={{ height: "1px", backgroundColor: "#f1f5f9", margin: "16px 0" }} />

                  {/* Total */}
                  <Box style={{ display: "flex", flexDirection: "column" }}>
                    <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <Typography style={{ fontFamily: "Satoshi", fontWeight: "800", fontSize: "16px", color: "#1e293b", paddingLeft: "24px" }}>
                        <span style={{fontSize:"22px"}}>Total</span>
                      </Typography>
                      <Typography style={{ fontFamily: "Satoshi", fontWeight: "800", fontSize: "16px", color: "#1e293b", paddingRight:"8px" }}>
                        <span style={{fontSize:"22px"}}>{currency}{" "}</span>
                        <span style={{fontSize:"22px"}}>{displayTotal.toFixed(2)}</span>
                      </Typography>
                    </Box>
                    {/* {isRoundOffApplicable && (
                      <Box style={{ display: "flex", justifyContent: "flex-end", paddingRight: "8px", marginTop: "2px" }}>
                        <Typography style={{ fontFamily: "Satoshi", fontSize: "12px", color: "#666666", fontWeight: "700" }}>
                          Paid via {paymentDisplayName}
                        </Typography>
                      </Box>
                    )} */}
                  </Box>
                </Box>

                {/* Card 2: Payment method & Order type details */}
                <Box
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "12px",
                    border: "1px solid #f1f5f9",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.04)",
                    padding: "16px",
                    marginTop: "12px",
                    marginBottom: "24px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                  }}
                >
                  {/* Payment Method */}
                  <Box style={{ display: "flex", gap: "12px" }}>
                    <Box
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        // backgroundColor: `rgba(${hexToRgb(primaryColor || BUTTON_COLOR)}, 0.08)`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <PaymentMethodsIcon primaryColor={primaryColor || BUTTON_COLOR} />
                    </Box>
                    <Box style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "15px",
                          color: "#1e293b",
                        }}
                      >
                        <span style={{fontSize:'18px'}}>
                        Payment Method
                        </span>
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: primaryColor || BUTTON_COLOR,
                          marginTop: "2px",
                        }}
                      >
                        <span style={{fontSize:'18px'}}>
                        Paid via {orderPlace?.[0]?.payment_details?.[0]?.tnd_type || selectedTender?.tnd_type || "UPI"}
                        </span>
                      </Typography>
                    </Box>
                  </Box>

                  {/* Order Type */}
                  <Box style={{ display: "flex", gap: "12px" }}>
                    <Box
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        // backgroundColor: `rgba(${hexToRgb(primaryColor || BUTTON_COLOR)}, 0.08)`,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                      }}
                    >
                      <OTStatusIcon primaryColor={primaryColor || BUTTON_COLOR} />
                    </Box>
                    <Box style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "15px",
                          color: "#1e293b",
                        }}
                      >
                        <span style={{fontSize:'18px'}}>      
                        Order Type
                          </span>
                      </Typography>
                      <Typography
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "600",
                          color: primaryColor || BUTTON_COLOR,
                          marginTop: "2px",
                        }}
                      >
                        <span style={{fontSize:'18px'}}>
                        {orderPlace?.[0]?.order_type || "Dine In"}
                        </span>
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </>
            );
          })()}
        </Box>
      </div>

      {/* Sticky Bottom Footer */}
      <div
        style={{
          padding: "16px",
          paddingBottom: isFSR ? "calc(80px + env(safe-area-inset-bottom, 0px))" : "calc(16px + env(safe-area-inset-bottom, 0px))",
          backgroundColor: "#ffffff",
          borderTop: "1px solid #f0f0f0",
        }}
      >
        <Button
          variant="contained"
          onClick={handleClearStorage}
          style={{
            backgroundColor: primaryColor || BUTTON_COLOR,
            color: "#ffffff",
            fontSize: "16px",
            fontWeight: "700",
            fontFamily: "Satoshi",
            borderRadius: "8px",
            padding: "12px 0px",
            minWidth: "100%",
            textTransform: "none",
            boxShadow: "none",
          }}
        >
          Order Again
        </Button>
      </div>
    </Grid>
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer || {},
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    clearCart: () => {
      dispatch(clearCart());
    },
    clear_customer: () => {
      dispatch(clear_customer());
    },
    clear_order_details: () => {
      dispatch(clear_order_details());
    },
    clear_order_type: () => {
      dispatch(clear_order_type());
    },
    clear_last_order: () => {
      dispatch(clear_last_order());
    },
    clearStateData: () => {
      dispatch(clearStateData());
    },
    clear_applied_offer: () => {
      dispatch(clear_applied_offer());
    },
    associated_stores: (obj) => {
      dispatch(associated_stores(obj));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderSummary);
